/*
 *                     NOTICE
 *            COPYRIGHT 2025 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 * 
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

/**
 * An enumeration of the capabilities that are potentially available in this product.
 */
export let ProductCapability = /*#__PURE__*/function (ProductCapability) {
  ProductCapability["GA2_EXPERIENCE"] = "GA2 Experience";
  return ProductCapability;
}({});
//# sourceMappingURL=ProductCapability.js.map
